import { MouseEventHandler } from "react";
import { useDispatch } from "react-redux";

import { CaseDocumentAdmin } from "pwapi";

import { updateAdminDocument } from "shared/actions/admin/adminDocumentsActions";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "store/hooks";

import DocumentsForm from "./DocumentsForm";
import { shallowDocumentComparison } from "./editDocumentsFormUtils";

type EditDocumentsFormProps = {
  document: CaseDocumentAdmin;
  onDelete: Function;
  onClose: MouseEventHandler<HTMLButtonElement>;
};

const EditDocumentsForm = ({
  document,
  onDelete,
  onClose,
}: EditDocumentsFormProps) => {
  const dispatch = useDispatch();
  const useMergeCaseReportWorkflow = useAppSelector((state) =>
    selectFeatureFlag(state, "useMergeCaseReportWorkflow")
  );

  const handleOnSubmit = (updatedValues: any) => {
    const values = shallowDocumentComparison(
      document,
      updatedValues,
      useMergeCaseReportWorkflow
    ) as {
      [key: string]: any;
    };
    const submitForm = new FormData();
    submitForm.append("id", `${document.id}`);

    Object.keys(values)
      .filter((k) => k !== "file" && k !== "case")
      .forEach((key) => {
        submitForm.append(key, `${values[key]}`);
      });

    if (updatedValues.file) {
      submitForm.append("file_uploaded", updatedValues.file);
    }

    dispatch(updateAdminDocument(submitForm, onClose));
  };

  return (
    <DocumentsForm
      document={document}
      onSubmit={handleOnSubmit}
      onDelete={onDelete}
      onClose={onClose}
      isUploading={document.status === CaseDocumentAdmin.status.PENDING}
    />
  );
};

export default EditDocumentsForm;
